module.exports = __webpack_public_path__ + "static/media/Inter.var.f065685b.woff2";